import PropTypes from 'prop-types';

import { setAccountId, setGiftModalVisible, setUserId } from 'store/models/gift';
import { useDispatch } from 'store/utils';

import GiftIcon from 'components/Admin/Gift/gift.svg';

import 'components/Admin/Gift/Gift.less';

const Gift = ({ accountId, userId }) => {
    const dispatch = useDispatch();
    const onClick = () => dispatch([setAccountId(accountId), setUserId(userId), setGiftModalVisible(true)]);
    return (
        <div className="user-gift" onClick={onClick} data-qa="user-gift">
            <img src={GiftIcon} />
        </div>
    );
};

Gift.propTypes = {
    accountId: PropTypes.number,
    userId: PropTypes.number,
};

export default Gift;
